import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=d5c7a468&scoped=true"
import script from "./Notificacao.vue?vue&type=script&lang=js"
export * from "./Notificacao.vue?vue&type=script&lang=js"
import style0 from "./Notificacao.vue?vue&type=style&index=0&id=d5c7a468&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c7a468",
  null
  
)

export default component.exports